import moment from 'moment';
import { getLineContainerStartDate } from './line';
import { ILine } from '../global';
import { ITimelineInfo } from '../Types';
import maxBy from 'lodash.maxby';

export function createTimelineInfo(
  monthsInTimeline: number = 12,
  startingDate: moment.Moment = undefined,
) {
  startingDate = startingDate ? moment(startingDate).add(1, 'M') : moment();
  const start = moment(startingDate)
    .set({
      date: 1,
    })
    .subtract(1, 'month')
    .startOf('day');
  let endOfTimeline = moment(startingDate)
    .add(monthsInTimeline - 2, 'M')
    .startOf('day');
  endOfTimeline = moment().set({
    year: moment(endOfTimeline).year(),
    month: moment(endOfTimeline).month(),
    date: moment(endOfTimeline).daysInMonth(),
  });
  const totalMonths = Math.floor(endOfTimeline.diff(start, 'months', true)) + 1;
  const totalDays = endOfTimeline.diff(start, 'days', true);

  const month = start.clone();
  var months = [];

  for (let i = 0; i < monthsInTimeline; i++) {
    const clonedMonth = month.clone();
    months.push(clonedMonth);
    month.add(1, 'month');
  }

  return {
    start,
    end: endOfTimeline,
    totalMonths: totalMonths,
    totalDays,
    months,
  };
}

export function createTimelineHeaders(
  start: moment.Moment,
  totalMonths: number,
) {
  const months = [];
  for (let i = start.month(); i < totalMonths + start.month(); i++) {
    let month = i;
    if (month > 11) month -= 12;
    months.push(month);
  }
  return months;
}

export function updateTimelineToShowLine(
  line: ILine,
  timelineInfo: ITimelineInfo,
  setTimelineInfo: (...args) => any,
) {
  const { start, end, totalMonths } = timelineInfo;
  const lineStart = getLineContainerStartDate(line);
  const lastStage = maxBy(line.stages, 'start');
  const lineEnd = moment(lastStage.start);
  if (lineStart < start) {
    const newTimelineInfo = createTimelineInfo(totalMonths, lineStart);
    setTimelineInfo(newTimelineInfo);
  } else if (lineEnd > end) {
    const newTimelineInfo = createTimelineInfo(
      totalMonths,
      lineEnd.startOf('month').subtract(totalMonths - 2, 'M'),
    );
    setTimelineInfo(newTimelineInfo);
  }
}
